export const STATUS_OPTIONS = [
  { label: "All Status", value: "" },
  { label: "Opened", value: "opened" },
  { label: "Assigned", value: "assigned" },
  { label: "In Progress", value: "work_started" },
  { label: "Completed", value: "work_completed" },
  { label: "Resolved", value: "resolved" },
  { label: "Rejected by Receptionist", value: "rejected" },
  { label: "Reopened", value: "re_opened" },
  { label: "Verified & Closed", value: "verified_and_closed" },
  { label: "Rejected by Manager", value: "rejected_by_mgr" },
];

export const PRIORITY_OPTIONS = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Critical", value: "critical" },
];

export const BREACHED_OPTIONS = [
  { label: "All Tickets", value: "" },
  { label: "Breached", value: "1" },
  { label: "Not Breached", value: "0" },
];

export const TICKET_TYPE_OPTIONS = [
  { label: "All", value: "" },
  { label: "Complaint", value: "complaint" },
  { label: "Requirement", value: "requirement" },
];
